import React from "react";
import Header from "../../component/Shared/Header/Header";

const Swap = () => {
  return (
    <>
      <Header />
    </>
  );
};

export default Swap;
